<template>
    <div v-if="schedule.segments.length > 0" class="bracket-eta-panel box has-no-glow-effect px-4 py-3 mb-0">
        <p class="is-size-7 has-text-grey-light is-uppercase has-text-weight-semibold mb-1">
            <span class="icon is-small mr-1"><i class="fa fa-calendar" /></span>
            {{ translate("common.eta") }}
        </p>

        <div
            v-for="segment in schedule.segments"
            :key="segmentKey(segment)"
            class="bracket-eta-row is-flex is-align-items-center py-1"
            :class="{ 'is-compact': compact }"
        >
            <div v-if="hasMarker(segment)" class="bracket-eta-marker">
                <ScheduleSegmentTag
                    :from="segment.roundMarkerFrom as RoundMarker | null"
                    :to="segment.roundMarkerTo as RoundMarker | null"
                    :assignment-type="segment.assignmentType"
                />
            </div>
            <p class="bracket-eta-time">
                <span class="has-text-white has-text-weight-semibold">{{
                    formatBracketScheduleEta(segment, eventTimezone, schedule.showDayName)
                }}</span>
                <span v-if="segment.matName" class="is-size-7 has-text-grey-light ml-2">{{ segment.matName }}</span>
            </p>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { translate } from "../Common/translations";
    import type { PublicBracketSchedule, PublicBracketScheduleSegment } from "../Api/brackets";
    import ScheduleSegmentTag from "../Schedules/ScheduleSegmentTag.vue";
    import type { RoundMarker } from "../Schedules/Managing/dropZoneItems";
    import { formatBracketScheduleEta } from "./bracketScheduleEta";

    withDefaults(
        defineProps<{
            schedule: PublicBracketSchedule;
            eventTimezone: string;
            compact?: boolean;
        }>(),
        { compact: false },
    );

    function hasMarker(segment: PublicBracketScheduleSegment): boolean {
        return segment.roundMarkerFrom !== null || segment.roundMarkerTo !== null || segment.assignmentType > 1;
    }

    function segmentKey(segment: PublicBracketScheduleSegment): string {
        return `${segment.scheduleId}-${segment.start}-${segment.roundMarkerFrom}-${segment.assignmentType}`;
    }
</script>
